import StudioSettings from "$root/functional-areas/portfolio-studio-settings";

const PortfolioStudioSettings = (): React.JSX.Element => <StudioSettings />;

export default PortfolioStudioSettings;
